import React from "react";
import classNames from "classnames";
import styles from "./Layout.module.scss";

export const ContainerMedium = ({children, className, style}) => {
    return <div className={classNames(className, styles['container-medium'])} style={style}>
        {children}
    </div>
};